export default [
    {
        path: '/jobsForProof',
        name: 'jobsForProof',
        component: () => import('@/views/JobsForProof/Index.vue'),
        meta: {
            title: 'jobsForProof.pageTitle',
            menuRendered: true,
            menuTitle: 'jobsForProof.menuTitle',
            requiresAuth: true,
            permission: 'proof_job',
            icon: 'mdi-cloud-check'
        }
    }
]
